import { render, staticRenderFns } from "./ReceiversList.vue?vue&type=template&id=c7a356f6"
import script from "./ReceiversList.vue?vue&type=script&lang=ts"
export * from "./ReceiversList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports